import axios from 'axios';
import {
  PerformanceAnalysisboardReq,
  WarningMessageFeatureValue,
} from '../models/PerformanceAnalysisboard';
import { ProductDataType, ProductType } from '../pages/product-analyzer/Product';
import { Filters } from '../utils/pageConfig/Types';
import { applyParamsBasedOnFilterPOST } from './utils/OverviewServiceUtils';
import { environment } from '../environments/environment';

type FeatureValueWarningMessageRequestBody = Pick<
  PerformanceAnalysisboardReq,
  | 'clientId'
  | 'productType'
  | 'productDataType'
  | 'country'
  | 'periodType'
  | 'productGroup'
  | 'brand'
  | 'split'
  | 'feature'
  | 'featureValue'
  | 'segmentFeature'
>;

export interface GetFeatureValueWarningMessageParams {
  clientId: number;
  productType: ProductType;
  productDataType: ProductDataType;
  countries: string[];
  periodType: string;
  productGroups: string[];
  appliedFilters: Filters[];
}

const constructRequestBody = ({
  clientId,
  productType,
  productDataType,
  countries,
  periodType,
  productGroups,
  appliedFilters,
}: GetFeatureValueWarningMessageParams) => {
  const request = {} as FeatureValueWarningMessageRequestBody;

  request.clientId = clientId;
  request.productType = productType;
  request.productDataType = productDataType;
  request.country = countries;
  request.periodType = periodType;
  request.productGroup = productGroups;

  applyParamsBasedOnFilterPOST(request, appliedFilters);

  return request;
};

export const getFeatureValueWarningMessage = async (
  params: GetFeatureValueWarningMessageParams,
  abortController: AbortController,
): Promise<WarningMessageFeatureValue> => {
  try {
    const { data } = await axios.post<WarningMessageFeatureValue>(
      `${environment.baseUrl}/v2/filters/warning-feature-value`,
      constructRequestBody(params),
      {
        signal: abortController.signal,
      },
    );
    return data;
  } catch (error: any) {
    throw new Error(`An error has occurred: ${error.message}`);
  }
};
